<template>
    <div :class="`${visible ? '' : 'sidebar-hidden '}fakes-sidebar sb-slidebar sb-right sb-style-overlay`">
        <h5 class="side-title">
            Распространённые фейки {{ items.length ? `(${items.length})` : '' }}
            <font-awesome-icon v-if="control" @click="addFakenIconClickHandler" class="add-fake" :icon="['fas', 'plus']" title="Добавить"/>
        </h5>
        <ul class="fakes-list quick-chat-list" @click="clickFakesListHandler" @mouseover="hoverFakesListHandler">
            <li v-for="fake in items" :data-id="fake.id" class="fake-li online">
                <div class="fake-el media">
                    <a href="#" class="media-thumb">
                        <div class="fake-thumb">
                            <img :src="fake.image" class="media-object">
                            <font-awesome-icon class="remove-fake"
                                               :icon="['fas', 'times']" title="Удалить"
                                               v-if="fake.active"
                                               @click="deleteFake(fake.id)"/>
                        </div>
                    </a>
                </div>
            </li>
        </ul>
        <div class="form-add-fake">
            <input type="file" multiple name="file" accept="image/*,image/jpeg" @change="addFakeImg">
        </div>
    </div>
</template>

<script>
    import permissions from '../mixins/permissions'
    import axios from '../../utils/axios'
    import Swal from 'sweetalert2'

    export default {
        name: "CommonFakes",
        mixins: [permissions],
        data() {
            return {
                visible: false,
                control: false,
                items: [],
                maxUploadCount: 10,
            }
        },
        watch: {
          visible(value) {
            if (value) {
                this.getData();
            }
            else {
                this.items = [];
            }
          }
        },
        async mounted() {
          const el = document.getElementById('ratingModerators');
          if (el) {
              el.addEventListener('click', () => {
                  this.visible = !this.visible;
              });
          }

          await this.getCurrentUser();
          if (this.current_user.admin_level > 10) {
              this.control = true;
          }
        },
        methods: {
            getData() {
                axios.get('/api/v1/common-fakes/get-common-fakes')
                    .then(response => {
                        if (response.data.success && response.data.data) {
                            this.items = response.data.data;
                        }
                    })
                    .catch(error => {

                    })
            },
            add(data) {
                axios.post('/api/v1/common-fakes/add-common-fakes', data)
                    .then(response => {
                        if (response.data.success) this.getData();
                    })
                    .catch(error => {

                    });
            },
            deleteFake(id) {
                axios.delete(`/api/v1/common-fakes/delete/${id}`)
                    .then(response => {
                        if (response.data.success) this.getData();
                    })
                    .catch(reason => {

                    });

            },
            addFakenIconClickHandler() {
                document.querySelector('.form-add-fake > input').click();
            },
            hoverFakesListHandler(e) {

                if (!this.control) return;

                const li = e.target.closest('.fake-li');
                if (!li) return;

                const id = li.dataset.id;
                if (!id) return;

                this.items = this.items.map(item => {
                    item.active = item.id == id;
                    return item;
                })
            },
            clickFakesListHandler(e) {
                if (e.target.tagName.toLowerCase() == 'img') {

                    const li = e.target.closest('.fake-li');
                    if (!li) return;

                    const id = li.dataset.id;
                    if (!id) return;

                    const fake = this.items.find(el => el.id == id);
                    if (!fake) return;

                    this.zoomFakeImg(fake.image);
                }
            },
            async addFakeImg(e) {
                const files = e.target.files;

                if (files.length > this.maxUploadCount) {
                    Swal.fire({
                        type: 'error',
                        title: `Предупреждение (больше ${this.maxUploadCount})!`,
                        text: `Количество загружаемых файлов не должно быть больше чем ${this.maxUploadCount}!`,
                    })
                }

                const reg_image = /^image\//;

                const data = new FormData();

                for (let i in files) {
                    if (typeof (files[i]) === 'object' && reg_image.test(files[i].type)) {
                        data.append(`file_${i+1}`, files[i]);
                    }
                }

                this.add(data);
            },
            zoomFakeImg(src) {
                Swal.fire({
                    imageUrl: src,
                    width: 'auto',
                    showConfirmButton: false,
                    showCloseButton: true,
                    customClass: 'fakeImg',
                });
            },
            async addFakeImage(src) {
                let ids = this.items.map(el => el.id);

                if (ids.length === 0) {
                    ids = [0];
                }

                await this.items.push({
                    img: src,
                    active: false,
                    id: Math.max(...ids)+1
                })
            },
        }
    }
</script>

<style scoped>
    .fakes-sidebar {
        margin-right: -285px;
        transform: translate(-285px);
        width: 20%;
        z-index: 1000;
        opacity: 1;
        transition-property: margin, transform, width, opacity;
        transition-duration: .2s;
    }
    .sidebar-hidden {
        margin-right: 0;
        transform: translate(0px);
        opacity: 0;
        width: 0;
        transition-property: margin, transform, width, opacity;
        transition-duration: .2s;
    }
    .side-title {
        text-transform: unset;
        color: #aeb2b7;
        text-align: center;
        padding: 10px 15px;
    }
    .fakes-list {
        margin-bottom: 70px;
    }
    .add-fake {
        color: greenyellow;
        float: right;
        cursor: pointer;
    }
    .fake-el {
        margin: 0 auto;
        width: 75%;
    }
    .fake-el > a {
        width: 100%;
        display: block;
    }
    .fake-thumb {
        position: relative;
        display: block;
        margin: 0 auto;
        width: 150px;
        height: 150px;
    }
    .fake-el > a img {
        width: 100% !important;
        height: 100% !important;
        cursor: zoom-in;
    }
    .remove-fake {
        position: absolute;
        top: 0;
        right: 5px;
        font-size: 1.5em;
        color: #ff6c60;
    }
    .fakeImg {
        z-index: 9999 !important;
    }
    .form-add-fake {
        display: none;
    }
    @media screen and (max-width: 1380px) {
        .fake-thumb {
            width: 100px;
            height: 100px;
        }
        .remove-fake {
            font-size: 1em;
        }
    }
    .sb-slidebar {
      height: 100%;
      overflow-y: auto;
      position: fixed;
      right: 0;
      top: 0;
      z-index: 0;
      font-size: 12px;
      background-color: #222;
    }

    .sb-slidebar {
      background-color: #2a3542 !important;
      margin-top: 60px;
      color: #aeb2b7;
    }

    .quick-chat-list .media .media-object {
        border-radius: 50% !important;
    }

    .quick-chat-list li {
        padding: 10px 15px;
        border-bottom: 1px dashed #35404d;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/users/CommonFakes.vue